import { InvokeCallback, Sender } from "xstate";
import { AxiosError } from "axios";
import { withToken } from "@rentablo/api";
import {
  listAndSearchAllAccountHolders,
  usersMyself,
} from "@rentablo/api/apiv1";
import { NetfondsConsentEvent } from "../netfondsConsentSM";

export const loadAccountHolders =
  (): InvokeCallback<NetfondsConsentEvent, NetfondsConsentEvent> =>
  (callback) => {
    const getMyself = withToken(usersMyself);
    const getAccountHolders = withToken(listAndSearchAllAccountHolders);
    getMyself()
      .then((myself) => {
        getAccountHolders({ userId: [myself.id!] })
          .then((data) => {
            callback({
              type: "INIT",
              accountHolders: data.accountHolders ?? [],
            });
          })
          .catch((error) => {
            somethingWrong(callback, error);
          });
      })
      .catch((error) => {
        somethingWrong(callback, error);
      });
  };

const somethingWrong = (
  callback: Sender<NetfondsConsentEvent>,
  error: AxiosError<ApiException>
) => {
  callback({
    type: "SOMETHING_WRONG",
    error: error,
  });
};
